import { useState } from 'react'
import { healAtChurch } from '@/economy/api'
import { useEconomyStore } from '@/state/useEconomyStore'
import type { WalletInfo } from '@/economy/types'
import type { InteractionTarget } from '@/state/useEconomyStore'

interface PanelProps { interaction: InteractionTarget; wallet: WalletInfo | null }

export function ChurchPanel({ wallet }: PanelProps) {
  const healCost = 25
  const canHeal = wallet && wallet.follis >= healCost
  const [healing, setHealing] = useState(false)
  const [healed, setHealed] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const setWallet = useEconomyStore((s) => s.setWallet)

  async function handleHeal() {
    setHealing(true)
    setError(null)
    try {
      const newWallet = await healAtChurch(healCost)
      setWallet(newWallet)
      setHealed(true)
      setTimeout(() => setHealed(false), 3000)
    } catch (e: any) {
      setError(e.message || 'Healing failed')
    }
    setHealing(false)
  }

  return (
    <>
      <div className="panel-section">
        <h3 className="panel-section__title">Services</h3>
        {error && <div className="panel-error">{error}</div>}
        <div className="panel-row">
          <span className="panel-row__label">Heal Wounds</span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span className="panel-row__value">{healCost}ƒ</span>
            <button
              className="panel-btn"
              disabled={!canHeal || healing}
              onClick={handleHeal}
            >
              {healing ? 'Healing...' : healed ? 'Healed!' : 'Heal'}
            </button>
          </span>
        </div>
        {healed && (
          <p style={{ color: '#6b8b4a', fontFamily: 'Crimson Text, serif', fontSize: 13, marginTop: 4 }}>
            Your wounds have been mended. Go in peace.
          </p>
        )}
        <div className="panel-row">
          <span className="panel-row__label">Bless Voyage</span>
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span className="panel-row__value" style={{ color: '#8b7355' }}>Coming soon</span>
          </span>
        </div>
      </div>

      <div className="panel-section">
        <h3 className="panel-section__title">Notice Board</h3>
        <p style={{ color: '#8b7355', fontFamily: 'Crimson Text, serif', fontSize: 13, lineHeight: 1.6 }}>
          "The seas grow restless. Merchant ships report pirates lurking near the northern straits.
          May the winds carry you safely to port."
        </p>
      </div>
    </>
  )
}
